import React from "react"

const Hero = props => {
  return (
    <article className="hero">
      <div className="container">
        <h1 className="fade-in">
          My name is <span className="large">Ken Walton</span>.
        </h1>
        <h2 className="fade-in-delay-1">
          I am a <span className="large">Front-End Developer</span> and{" "}
          <span>Project Management Professional</span> with a Graphic Design
          background based in the Greater Hartford area.
        </h2>
      </div>
    </article>
  )
}

export default Hero
